export default __webpack_public_path__ + "static/media/a020-ngo-2.2e2d7b6b.svg";